import { Observable, forkJoin, map } from 'rxjs';
import { Menu } from 'src/app/shared/model/security/menu.model';

/** El sitio del modulo Base: Empleados, Perfiles, Areas y Horarios. */
export const SITIO_BASE = 'BASE';

/** Lo unico del servicio que usa el arbol: la consulta de menus por sitio. */
export interface ConsultaMenusPorSitio {
  ConsultaMenus(sitio: string): Observable<Menu[]>;
}

/**
 * Los sitios cuyo arbol pinta el editor de Configuracion > Perfiles: el del
 * perfil y, si no es Base, tambien Base.
 *
 * Por que Base: las hojas de Personas (Empleados, Horarios, Asignacion de
 * horarios) y de Configuracion (Perfiles, Areas) son de sitio BASE. Un
 * perfil de COS o de ASISTENCIA puede tenerlas, pero el editor solo pintaba
 * el arbol de su sitio: no habia casilla para darlas ni para quitarlas. El
 * servidor reemplaza exactamente los sitios que este editor pinta
 * (PerfilBuss.sitiosQuePintaElEditor), asi que las dos listas deben ser la
 * misma.
 */
export function sitiosDelEditor(sitio: string | null | undefined): string[] {
  const propio = (sitio ?? '').trim();
  if (!propio) {
    return [];
  }
  return propio === SITIO_BASE ? [SITIO_BASE] : [propio, SITIO_BASE];
}

/**
 * El arbol completo del editor: primero el del sitio del perfil, luego el
 * de Base con sus grupos marcados "(Base)", porque los dos sitios tienen
 * un grupo Personas y uno Configuracion y sin la marca se verian repetidos.
 *
 * Si una de las dos consultas falla, falla todo: pintar solo una mitad y
 * guardar le quitaria al perfil las hojas de la otra sin que nadie las
 * hubiera desmarcado.
 */
export function arbolDelEditor(servicio: ConsultaMenusPorSitio, sitio: string): Observable<Menu[]> {
  const sitios = sitiosDelEditor(sitio);
  return forkJoin(sitios.map((s) => servicio.ConsultaMenus(s))).pipe(
    map((arboles) =>
      arboles.flatMap((arbol, i) => {
        const raices = Array.isArray(arbol) ? arbol : [];
        if (sitios[i] !== SITIO_BASE || sitios.length === 1) {
          return raices;
        }
        return raices.map((raiz) => ({ ...raiz, nombre: `${raiz.nombre} (Base)` }));
      })
    )
  );
}
